import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { Fetcher } from '../../../../shared/organizationPackages/filters';

const fetchPackageManagers = () => get<Fetcher[]>('/api/packages/package-managers', true);

export const packageManagersQueryKey: QueryKey = ['packages', 'package-managers'];

const usePackageManagersQuery = () => useQuery<Fetcher[]>({
  queryKey: packageManagersQueryKey,
  queryFn: fetchPackageManagers,
  staleTime: 1000 * 60 * 10,
});

export default usePackageManagersQuery;
